import {useMutation, useQueryClient} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

// Staff-only: hide / unhide a not-yet-printed trip from an agency's listing.
export function useHiddenUnits(agencyId: string) {
    const queryClient = useQueryClient()

    const invalidate = () => {
        queryClient.invalidateQueries({queryKey: ['b2b-pack-detail', agencyId]})
        queryClient.invalidateQueries({queryKey: ['b2b-agency-activity', agencyId]})
    }

    const hideMutation = useMutation({
        mutationFn: ({tripId, reason}: {tripId: string; reason: string | null}) =>
            b2bMetricsRepository.hideUnit(agencyId, tripId, reason),
        onSuccess: invalidate,
    })

    const unhideMutation = useMutation({
        mutationFn: (tripId: string) => b2bMetricsRepository.unhideUnit(agencyId, tripId),
        onSuccess: invalidate,
    })

    return {
        hideUnit: hideMutation.mutateAsync,
        unhideUnit: unhideMutation.mutateAsync,
        isChangingHidden: hideMutation.isPending || unhideMutation.isPending,
    }
}
